import { useContext } from "react";
import PropTypes from "prop-types";
import { PolicyContext } from "./context";

const PolicyTitle = ({ children, id }) => {
    const { toggleActive, activeId, setIsInit } = useContext(PolicyContext);

    const clickHandler = () => {
        if (!toggleActive || !id || !setIsInit) return;
        setIsInit(false);
        toggleActive(id);
    };
    const isActive = id === activeId ? true : false;

    return (
        <div
            aria-hidden="true"
            className={`accordion-header ${isActive ? "active" : ""}`}
            type="button"
            onClick={clickHandler}
        >
            <span className="accordion-title">{children}</span>
        </div>
    );
};

PolicyTitle.propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PolicyTitle;
